import React, { useEffect, useState } from 'react';
// @ts-ignore
import styles from './LaboratoryResultsListItem.module.scss';
import Checkbox from '../../../../Components/Base/Checkbox/Checkbox';
import TreatmentPatientButton from '../../../../Components/Treatment/TreatmentPatientButton';
import Button from '../../../../Components/Button/Button';
import { Theme } from '../../../../Enums/Theme.enum';
import moment from 'moment';
import { useAppContext } from '../../../../Services/AppContext';
import {
	LaboratoryResultResult,
	useHideSeenLaboratoryResultsMutation,
	User,
} from '../../../../graphql/graphql';
import useTranslation from '../../../../Hooks/useTranslation';
import usePatientIdentification from '../../../Patient/Hooks/usePatientIdentification';
import LaboratoryResultModal from '../LaboratoryResultsList/LaboratoryResultModal';

interface Props {
	item: LaboratoryResultResult;
	isSelected: boolean;
	onSelect: (item: LaboratoryResultResult, add: boolean) => void;
	onUnseen: () => void;
}

const LaboratoryResultsListItem: React.FC<Props> = ({
	item,
	onSelect,
	isSelected,
	onUnseen,
}) => {
	const [markAsSeen] = useHideSeenLaboratoryResultsMutation();
	const [isChecked, setIsChecked] = useState(false);
	const [isDetailOpened, setIsDetailOpened] = useState(false);
	const { dateFormatMoment, workplaceId, userData, socketUrl } =
		useAppContext();
	const { t } = useTranslation();
	const { identification } = usePatientIdentification(item.user as User);

	useEffect(() => {
		setIsChecked(isSelected);
	}, [isSelected]);

	useEffect(() => {
		onSelect(item, isChecked);
	}, [isChecked]);

	const handleCheckItem = () => {
		setIsChecked(prev => !prev);
	};

	const handleMarkItemNotSeen = async () => {
		if (item.user?.id) {
			setIsChecked(false);
			await markAsSeen({
				input: { isSeen: false, laboratoryResultIds: [item.id] },
			});
		}
		onUnseen();
	};

	return (
		<>
			<div className={styles.item}>
				<div className={styles.patient}>
					{item.isSeen ? (
						<div onClick={() => handleMarkItemNotSeen()}>
							<img
								src='/dist/icons/eye.svg'
								alt='eye'
								width='17px'
								style={{ marginRight: '8px', cursor: 'pointer' }}
							/>
						</div>
					) : (
						<Checkbox value={isChecked} onChange={handleCheckItem} />
					)}
					<div className={styles.patientData}>
						<div className={styles.text}>
							{moment(item.createdAt).format(dateFormatMoment + ' HH:mm')}
						</div>
						{item?.user?.id && (
							<TreatmentPatientButton
								text={item?.user?.profile?.fullName ?? ''}
								patientId={item?.user?.id}
								workplaceId={workplaceId}
								loggedUserId={userData.id}
								className={styles.title}
							/>
						)}
						{identification.value && identification.title && (
							<div className={styles.extra}>
								<div className={styles.name}>
									<span>{t(identification.title)}: </span>
									{identification.value}
								</div>
							</div>
						)}
					</div>
				</div>
				<div className={styles.content}>
					<div>
						<div className={styles.title}>
							{t('component.laboratoryResultsListItem.resultsForm')}{' '}
							{item.laboratory?.name}
						</div>
					</div>
					{item.isSeen && (
						<div className={styles.extra}>
							<div className={styles.name}>
								<span>{t('base.seenBy')}: </span>
								{item.isSeenMarkedBy?.profile?.fullName}
							</div>
						</div>
					)}
				</div>
				<div className={styles.controls}>
					<Button
						title='base.preview'
						theme={Theme.GREEN}
						onClick={() => setIsDetailOpened(true)}
					/>
				</div>
			</div>
			{isDetailOpened && (
				<LaboratoryResultModal
					isOpen
					onClose={() => setIsDetailOpened(false)}
					patientId={item.user.id}
					selectedItem={item}
				/>
			)}
		</>
	);
};

export default LaboratoryResultsListItem;
